export interface NormalizedScript {
  content: string;
  type?: string;
}

const JSON_LD_TYPE = 'application/ld+json';

const looksLikeJson = (s: string) => {
  if (!s.startsWith('{') && !s.startsWith('[')) {
    return false;
  }
  try {
    JSON.parse(s);

    return true;
  } catch {
    return false;
  }
};

const inferType = (explicit: string | undefined, content: string) => {
  if (explicit) {
    return explicit;
  }
  if (looksLikeJson(content)) {
    return JSON_LD_TYPE;
  }

  return undefined;
};

export const normalizeScript = (js: string): NormalizedScript => {
  const s = js.trim();
  if (!s) {
    return { content: '' };
  }

  if (s.startsWith('<script')) {
    const contentMatch = s.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
    const typeMatch = s.match(/<script[^>]*\stype\s*=\s*["']([^"']+)["']/i);
    const content = contentMatch ? contentMatch[1].trim() : s;

    return { content, type: inferType(typeMatch?.[1], content) };
  }

  if (looksLikeJson(s)) {
    return { content: s, type: JSON_LD_TYPE };
  }

  return { content: s };
};
